export enum Browsers {
    chrome,
    safari,
    firefox,
    edge,
    opera
}
